import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { MyTripsFilter } from "@hopper-b2b/types";
import { ButtonWrap } from "@hopper-b2b/ui";
import {
  useEnablePriceFreeze,
  useEnablePriceWatch,
} from "@hopper-b2b/utilities";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface TripTabsFilterProps {
  onClick: (filter: MyTripsFilter) => void;
  selectedFilter: MyTripsFilter;
}

export const TripTabsFilter = ({
  onClick,
  selectedFilter,
}: TripTabsFilterProps) => {
  const { t } = useI18nContext();
  const showFlightPriceFreeze = useEnablePriceFreeze();
  const showFlightPriceWatch = useEnablePriceWatch();
  const showFlights = true;

  const tabs = useMemo(
    () => [
      {
        label: t("upcomingFilterButton"),
        value: MyTripsFilter.UPCOMING_TRIPS,
        onClick: () => onClick(MyTripsFilter.UPCOMING_TRIPS),
        className: "upcoming",
      },
      ...(showFlights
        ? [
            {
              label: t("flights"),
              value: MyTripsFilter.FLIGHTS,
              onClick: () => onClick(MyTripsFilter.FLIGHTS),
              className: "flights",
            },
          ]
        : []),
      ...(showFlightPriceFreeze
        ? [
            {
              label: t("priceFreezeButton"),
              value: MyTripsFilter.PRIZE_FREEZES,
              onClick: () => onClick(MyTripsFilter.PRIZE_FREEZES),
              className: "price-freeze",
            },
          ]
        : []),
      ...(showFlightPriceWatch
        ? [
            {
              label: t("priceWatchButton"),
              value: MyTripsFilter.WATCHED_TRIPS,
              onClick: () => onClick(MyTripsFilter.WATCHED_TRIPS),
              className: "price-watch",
            },
          ]
        : []),
      {
        label: t("pastFilterButton"),
        value: MyTripsFilter.PAST_TRIPS,
        onClick: () => onClick(MyTripsFilter.PAST_TRIPS),
        className: "past",
      },
    ],
    [onClick, showFlightPriceFreeze, showFlightPriceWatch, showFlights, t]
  );

  return (
    <div className={styles.TripTabsFilter}>
      {tabs.map((tab, i) => (
        <ButtonWrap
          onClick={tab.onClick}
          key={tab.value}
          className={clsx(
            styles.TabFilter,
            tab.className,
            tab.value === selectedFilter ? styles.Selected : null,
            i === 0 ? styles.First : null
          )}
        >
          {tab.label}
        </ButtonWrap>
      ))}
    </div>
  );
};
